/* eslint-disable */
Array.prototype.insert = function (index, ...items) {
  if (isNaN(index)) throw new Error('please enter a number')
  this.splice(index, 0, ...items)
}
